module.exports = __webpack_public_path__ + "img/img-8.260db86a.svg";